<template>
    <div class="print-request">
        <div class="columns">
            <div class="column is-12">
                <div class="columns">
                    <div class="column is-12">
                        <div class="job-number">Job# {{formData[0].job_no}}</div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-12">
                        <table>
                            <thead>
                                <tr>
                                    <th colspan="2">Job Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td width="250">Job No.</td>
                                    <td>{{formData[0].job_no}}</td>
                                </tr>
                                <tr>
                                    <td width="250">Service Date</td>
                                    <td>{{formData[0].service_date}}</td>
                                </tr>
                                <tr>
                                    <td width="250">Service Time</td>
                                    <td>{{formData[0].service_time}}</td>
                                </tr>
                                <tr>
                                    <td width="250">Target Language</td>
                                    <td>{{formData[0].language}}</td>
                                </tr>
                                <tr>
                                    <td width="250">Service Description</td>
                                    <td>{{formData[0].service_description}}</td>
                                </tr>
                                <tr>
                                    <td width="250">Case Name/LEP</td>
                                    <td>{{formData[0].case_name_lep}}</td>
                                </tr>
                                <tr>
                                    <td width="250">Case No./MRN</td>
                                    <td>{{formData[0].case_num_mrn}}</td>
                                </tr>
                                <tr>
                                    <td width="250">Facilitator</td>
                                    <td>{{formData[0].contact_name}}</td>
                                </tr>
                                <template v-for="rate in vendorPayment" :key="rate.rate_type_id">
                                    <tr v-if="rate.rate != 0">
                                        <td width="250">{{rate.rate_type_name}}</td>
                                        <td>{{rate.details}}</td>
                                    </tr>
                                </template>
                                <tr>
                                    <td width="250">Cancellation Policy</td>
                                    <td>{{formData[0].cancellation_policy}}</td>
                                </tr>
                                <tr>
                                    <td width="250">Special Instructions</td>
                                    <td>{{formData[0].special_instructions}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            statusClass: '',
            showNotes: ''

        }
    },

    computed: {

        ...mapState('exportRequest', {
            formData: state => state.formData,
            user: state => state.user,
            remarksData: state => state.remarksData,
            vendorPayment: state => state.vendorPayment,
        }),

    },

    methods: {
        processData(){
            //this.formData = JSON.parse(sessionStorage.getItem("CLIENT-REQUEST-FORM-DATA"));
            //this.user = JSON.parse(sessionStorage.getItem("USER"));
            //this.statusClass = sessionStorage.getItem("statusClass");
            //var showNotesTxt = sessionStorage.getItem("showNotes");

            this.statusClass = sessionStorage.getItem("statusClass");
            var showNotesTxt = sessionStorage.getItem("showNotes");

            if(showNotesTxt == 'true'){
                this.showNotes = true;
            }else{
                this.showNotes = false;
            }

            //console.log(this.formData);

        }
    },

    created(){
        VueStore.dispatch('exportRequest/pageDone');
    },

    mounted(){
        // temporary set sessionstorage
        window.onbeforeunload = function(event)
        {
            VueStore.dispatch('exportRequest/pageRefresh');
        };

        this.processData();
        $('body').addClass('print-view');

    }
}
</script>


<style>
    html{
        overflow-y: hidden !important;
    }

    body.print-view{
        overflow-y: scroll;
        overflow-x: hidden;
        background-color: #FFFFFF !important;
    }

    body.print-view table{
        table-layout: auto !important;
    }

    body.print-view #app .print-request{
        max-width: 75rem;
        margin-right: auto;
        margin-left: auto;
    }

    body.print-view {
        padding-right: 2rem;
        padding-left: 2rem
    }

    body.print-view .print-request {
        margin-top: 20px;
    }

    body.print-view #app {
        margin: 2.25rem auto;
    }

    body.print-view h1 {
        color: #006FC0;
        font-size: 1.5rem;
        font-weight: 600;
    }

    body.print-view table {
        border-spacing: 0;
        width: 100%;
        margin-top: 1.5rem;
    }

    body.print-view table th {
        font-weight: 700;
        color: #006FC0;
        padding: 5px;
        background-color: #DBE6F0;
        font-size: 1.125rem;
        border: 1px solid #c1c1c1;
        border-bottom: none;
        text-align: center !important;
    }

    body.print-view table tr td {
        font-size: 0.875rem;
        padding: 5px;
        border-top: 1px solid #c1c1c1;
        border-left: 1px solid #c1c1c1;
        border-right: 1px solid #c1c1c1;
        border-bottom: none;
    }

    body.print-view table tr td {
        white-space: pre-wrap !important;
    }

    body.print-view table tr td:last-child, body.print-view table tr td:nth-last-child(2) {
        border-bottom: 1px solid #c1c1c1;
    }

    body.print-view table tr td:first-child {
        font-weight: bold;
    }

    body.print-view .job-number {
        font-size: 1.25rem;
        text-align: right;
        margin-top: 0.25rem;
    }

    body.print-view .internal-use {
        background-color: #E6B7B8;
        color: #632324;
    }


    @media print {
        body.print-view{
            overflow-y: hidden;
            overflow-x: hidden;
            zoom: 80%;
        }
        body.print-view table tr td, body.print-view table th {
            padding: 2px;
        }

        body.print-view .column{
            padding: 0;
        }
    }
</style>
